// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__YF1II","footerCollapsed":"Footer_footerCollapsed__kGvF2","copyright":"Footer_copyright__rtAb0"};